import React from 'react';
import {Card, Divider} from '@mui/material';
import clsx from 'clsx';

import {BasicCardProps} from '../types/BasicCardProps';

type BasicCardComponent = React.ForwardRefExoticComponent<
  React.PropsWithoutRef<BasicCardProps> & React.RefAttributes<HTMLDivElement>
>;

export const BasicCard: BasicCardComponent = React.forwardRef<HTMLDivElement, BasicCardProps>(
  (
    {
      dataTestId,
      borderRadiusSize,
      bottomDivider,
      borderStyle,
      cardColor,
      cardType,
      hasGutterBottom,
      children,
      zeroPadding,
      sx,
      ...rest
    },
    ref
  ) => {
    const updatedDataTestId = dataTestId ? `${dataTestId}-` : '';

    return (
      <Card
        className={clsx(
          'Material-baseCard',
          `${cardColor}Card`,
          borderRadiusSize || 'mediumBorderRadius',
          cardType,
          zeroPadding && 'zeroPadding',
          hasGutterBottom && 'hasGutterBottom',
          borderStyle === 'dashed' && 'dashedBorder'
        )}
        elevation={borderStyle === 'raised' ? 2 : 0}
        variant={borderStyle === 'outlined' ? 'outlined' : undefined}
        data-testid={`${updatedDataTestId}basic-card`}
        ref={ref}
        // This lint error should be fixed, but the correct fix is not obvious.  The "sx" prop
        // can actually be an object, an array, or a function; all three scenarios need to be
        // accounted for here.  Right now this code only works correctly if the value of "sx"
        // is an object.
        // eslint-disable-next-line @typescript-eslint/no-misused-spread
        sx={{backgroundColor: cardColor, ...sx}}
        {...rest}
      >
        {children}
        {bottomDivider && <Divider sx={{my: 3}} />}
      </Card>
    );
  }
);
